<template>
  <main>
    <div class="activity-id-label">
      <p>Activity ID</p>
      <input type="text" name="activity-id" class="activity-id" v-model="activityId" />
      <button class="activity-id-go" v-on:click.prevent="launchByActivityId()">GO</button>
    </div>
    <div class="activity-variants">
      <h2>Activity Variants</h2>
      <ul>
        <li
          v-for="item in kwtActivities"
          :key="item.variant"
          v-on:click.prevent="launchByActivityTypeVariant(item.variant)"
          class="newJson"
        >
          <button>
            {{ item.displayName }}
            <span>{{ item.variant }}</span>
          </button>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import sortBy from 'lodash/sortBy';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { activityTypeVariantData } from 'utils/activity-type-variant-util';

export default {
  mounted() {
    this.$nextTick(() => {
      this.setToolbarMode('fullScreenOnly');
      this.setKwtMode('tester');
      this.resetActivityStore();
      this.resetKeyboard();
    });
  },

  data() {
    return {
      activityId: ''
    };
  },

  computed: {
    ...mapState('activity', {
      activityData: 'data'
    }),
    ...mapGetters('activity', ['activityTitle']),

    kwtActivities() {
      return sortBy(activityTypeVariantData, 'displayName');
    }
  },

  methods: {
    ...mapMutations('application', ['setToolbarMode', 'setKwtMode']),
    ...mapActions('activity', ['fetchActivityData', 'fetchRandomDataForActivityTypeVariant']),

    ...mapMutations('activity', ['resetActivityStore']),
    ...mapMutations('keyboard', ['resetKeyboard']),

    async launchByActivityTypeVariant(variant) {
      await this.fetchRandomDataForActivityTypeVariant(variant);
      this.launchActivity();
    },
    async launchByActivityId() {
      if (!this.activityId) return;

      await this.fetchActivityData({ activityId: this.activityId });
      this.launchActivity();
    },
    launchActivity() {
      const { $router, $nextTick, activityTitle: { name } = {} } = this;
      $nextTick(() => $router.push({ path: `activities/${name}` }));
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-family: 'hwtfutura-semibold';
  font-size: 15px;
  padding: 0;
  margin: 10px 0 0 0;
  text-transform: uppercase;
  & em {
    text-transform: none;
  }
}
.activity-id-label {
  text-align: center;
  padding: 10px 0 0 0;
  p {
    font-family: 'hwtfutura-bold';
    display: inline-block;
    margin-right: 5px;
    color: black;
  }
}
.activity-id {
  font-family: 'hwtfutura-bold';
  text-align: center;
  font-size: 16px;
  width: 100px;
  display: inline-block;
  border: 2px solid black;
  border-radius: 5px;
  height: 30px;
  padding: 0;
  line-height: 30px;
}
.activity-id-go {
  display: inline-block;
  border: none;
  margin-left: 5px;
  font-size: 18px;
  font-family: 'hwtfutura-bold';
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  background-color: black;
  color: white;
}
.activity-variants {
  margin: 15px auto 0 auto;
  width: 980px;
  // height: 700px;
  // overflow-y: scroll;
  ul {
    list-style: none;
    margin: 0;
    padding: 8px 0 12px;
    text-align: center;
    border-top: 1px solid #ccc;
    li {
      display: inline-block;
      margin: 2px;
      padding: 0;
      vertical-align: top;
      button {
        font-family: 'hwtprint-bold';
        border: none;
        height: 50px;
        vertical-align: top;
        padding: 0px 10px;
        font-size: 15px;
        border-radius: 5px;
        background-color: #95c88a;
        &.qa {
          background-color: #ff8a00;
        }
        &.qa:hover {
          background-color: #ff9c00;
        }
        &.dev {
          background-color: #ff0066;
        }
        &.dev:hover {
          background-color: #ff0000;
        }
        &:hover {
          background-color: #8de279;
        }
        &.disabled {
          opacity: 0.65;
          cursor: not-allowed;
          background-color: #ccc;
        }
        span {
          display: block;
          font-size: 12px;
          line-height: 10px;
          font-family: 'hwtfutura';
        }
      }
      &.newJson button {
        background: #f1da36; /* Old browsers */
        background: linear-gradient(to bottom, #f1da36 0%, #fefcea 120%);
      }
    }
  }
}
</style>
